import auth0 from 'auth0-js';
import { CONSTANTS_AUTH } from '../utils/constants';

export default class Auth {
    accessToken;
    idToken ;
    expiresAt;

    auth0 = new auth0.WebAuth({
        domain: CONSTANTS_AUTH.DOMAIN_NAME,
        clientID: CONSTANTS_AUTH.CLIENT_ID,
        redirectUri: CONSTANTS_AUTH.REDIRECT_URI,
        responseType: 'token id_token',
        scope: 'openid read:practitioners search:practitioners',
        audience: CONSTANTS_AUTH.AUDIENCE
    });

    constructor() {
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
        this.handleAuthentication = this.handleAuthentication.bind(this);
        this.isAuthenticated = this.isAuthenticated.bind(this);
        this.getAccessToken = this.getAccessToken.bind(this);
        this.getIdToken = this.getIdToken.bind(this);
        this.renewSession = this.renewSession.bind(this);
    }

    login() {
        this.auth0.authorize();
    }

    handleAuthentication() {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);
            } else if (err) {
                window.location.href = CONSTANTS_AUTH.HOME_PATH;
            }
        });
    }

    setAccessToken(accessToken) {
        this.accessToken = accessToken;
    }

    getAccessToken() {
        return this.accessToken !== undefined ?
            this.accessToken
            : localStorage.getItem('accessToken');
    }

    getIdToken() {
        return this.idToken;
    }

    setSession(authResult) {
        // Set the time that the access token will expire at
        let expiresAt = (authResult.expiresIn * 1000) + new Date().getTime();
        this.accessToken = authResult.accessToken;
        this.idToken = authResult.idToken;
        this.expiresAt = expiresAt;

        // Set isLoggedIn flag in localStorage
        localStorage.setItem('expiresAt', this.expiresAt);
        localStorage.setItem('accessToken', this.accessToken);
        localStorage.setItem('idToken', this.idToken);

        // navigate to the home route
        window.location.href = `${CONSTANTS_AUTH.HOME_PATH}dashboard`;
    }

    checkExistSession() {
        if (localStorage.getItem('expiresAt')
            && localStorage.getItem('accessToken')
            && localStorage.getItem('idToken')) {
            if (new Date().getTime() < localStorage.getItem('expiresAt')) {
                this.accessToken = localStorage.getItem('accessToken');
                this.idToken = localStorage.getItem('idToken');
                this.expiresAt = localStorage.getItem('expiresAt');
                return true
            }
        }
        return false;
    }

    renewSession() {
        this.auth0.checkSession({}, (err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);
            } else if (err) {
                this.logout();
                console.error(err);
                alert(`Could not get a new token (${err.error}: ${err.error_description}).`);
            }
        });
    }

    logout() {
        let uri = `${CONSTANTS_AUTH.HOME_PATH}dashboard`;

        if (this.accessToken === undefined) {
            uri = `${CONSTANTS_AUTH.HOME_PATH}guest/login`;
        }

        // Remove tokens and expiry time
        this.accessToken = null;
        this.idToken = null;
        this.expiresAt = 0;

        localStorage.removeItem('expiresAt');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('idToken');
        // navigate to the home route
        window.location.href = uri;
    }

    parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    isAuthenticated() {
        let expiresAt = parseInt(this.expiresAt);
        let now = new Date().getTime();

        return now < expiresAt;

    }
}


// WEBPACK FOOTER //
// ./src/auth/index.js